import moment from 'moment';

const tryParseDate = (value) => {
  if (value.includes('/')) {
    return moment(value, 'M/D/YYYY HH:mm:ss');
  } if (value.includes('.')) {
    return moment(value, 'DD.MM.YYYY hh:mm:ss');
  } if (value.includes('-')) {
    return moment(value, 'M-YYYY');
  }

  return moment(value);
};

export default tryParseDate;
